import { Pagination, paginationToParams } from '../Pagination';

export type ProductOrder =
  | 'orderByQuantityDesc'
  | 'orderByPriceAsc'
  | 'orderByPriceDesc'
  | 'orderByNameAsc'
  | 'orderByNameDesc';

export const productOrderNameMap: Record<ProductOrder, string> = {
  orderByQuantityDesc: 'Varsayılan',
  orderByPriceAsc: 'En Düşük Fiyat',
  orderByPriceDesc: 'En Yüksek Fiyat',
  orderByNameAsc: 'İsim (A-Z)',
  orderByNameDesc: 'İsim (Z-A)',
};

export interface GetProductsRequest extends Pagination {
  order: ProductOrder;
  filterIDs: number[];
}

export const getDefaultProductFilters = (): GetProductsRequest => ({
  order: 'orderByQuantityDesc',
  filterIDs: [],
  page: 0,
  pageSize: 20,
});

export const getProductsRequestToParams = (request: GetProductsRequest) => {
  return {
    order: request.order,
    ...(request.filterIDs.length
      ? { filterBy: request.filterIDs.map(String).join(',') }
      : {}),
    ...paginationToParams(request),
  };
};
